module.exports = __webpack_public_path__ + "img/no-permission.34c270cc.png";